// extracted by mini-css-extract-plugin
module.exports = {"margin":"CarInfoSection_margin__3nYPf"};